export default __webpack_public_path__ + "static/media/slav_s.e1a4dcf9.jpg";